import React from 'react';
import ReactDOM from 'react-dom/client';
import { SocketContextProvider } from './api/socketContext';
import App from './App';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('build-a-brain'));
root.render(
    <React.StrictMode>
        <SocketContextProvider>
            <App />
        </SocketContextProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
